import React, {Component} from 'react';

import './NameCard.css';

import { Avatar } from '@mui/material';

class NameCard extends Component {
	getInitials(fullname) {
		return fullname
			? fullname
				.replace(/\s+/g,' ')
				.trim()
				.split(' ')
				.slice(0, 2)
				.map((name) => name[0])
				.join('')
			: '?';
	}
	formatPhoneNumber(phoneNumber) {
		if (phoneNumber) {
			return phoneNumber.replace(/\s|-/g, '');
		}
	}
	render() {
		return (
			<div className="name-card">
				<Avatar className="name-card-avatar">{this.getInitials(this.props.fullname)}</Avatar>
				<div className="name-card-details">
					<p className="name-card-fullname">{this.props.fullname}</p>
					<p className="name-card-title">{this.props.title}</p>
					<a href={`tel:${this.formatPhoneNumber(this.props.phone)}`} className="name-card-phone" target="_blank" rel="noopener noreferrer">{this.props.phone}</a>
					<a href={`tel:${this.formatPhoneNumber(this.props.phone2)}`} className="name-card-phone" target="_blank" rel="noopener noreferrer">{this.props.phone2}</a>
				</div>
			</div>
		);
	}
}

export default NameCard;
